// extracted by mini-css-extract-plugin
module.exports = {"listItem":"_2wsAOOKTdDOJ8AKlESE7TU","link":"_33KbJ7TAtRUJnkjSQcRyCN"};